import React, { useState } from "react";

const faqs = [
  {
    question: "¿Necesito ser cliente del Banco Nación para usar Viajá+?",
    answer:
      "Sí. Viajá+ es un programa exclusivo para clientes del Banco Nación que operan con la app BNA+. Para financiar tu estadía en Alohar tenés que tener cuenta en el banco, la app instalada y cumplir las condiciones crediticias del banco."
  },
  {
    question: "¿Puedo financiar sólo el alojamiento o también otros gastos del viaje?",
    answer:
      "Podés financiar tu alojamiento y también otros gastos turísticos dentro de Argentina (por ejemplo gastronomía, balnearios, pasajes y alquiler de autos), siempre que estén dentro de las categorías habilitadas por Viajá+."
  },
  {
    question: "¿Dónde veo las tasas, montos y cuotas actuales?",
    answer:
      "Las condiciones se consultan siempre en la app BNA+ o en los canales oficiales del Banco Nación. Ahí vas a ver el monto máximo disponible, la tasa vigente y el plazo de financiación antes de confirmar la operación."
  },
  {
    question: "¿Alohar me otorga el crédito?",
    answer:
      "No. Alohar no otorga créditos ni financia directamente. El financiamiento lo brinda exclusivamente el Banco Nación a través de su programa Viajá+. Alohar es proveedor adherido donde podés usar ese beneficio para pagar tu estadía."
  },
  {
    question: "¿Qué pasa si el banco no aprueba mi crédito o mis cuotas?",
    answer:
      "En ese caso, podés seguir reservando y pagando en Alohar con los otros medios de pago disponibles de la plataforma, pero no vas a poder usar Viajá+ para esa reserva en particular."
  }
];

export default function AloharViajaMasLanding() {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <div className="viaja-container">
      {/* HERO */}
      <header className="viaja-hero">
        <div className="viaja-hero-content">
          <span className="viaja-pill">Programa oficial Banco Nación · Proveedor adherido</span>
          <h1>
            Pagá tu estadía en Alohar con <span className="viaja-highlight">Viajá+</span> del Banco Nación
          </h1>
          <p className="viaja-hero-text">
            Si sos cliente del Banco Nación, podés financiar tus vacaciones en Argentina y pagar
            tu alojamiento reservado en Alohar en cuotas fijas a través de <strong>Viajá+</strong>.
          </p>
          <div className="viaja-hero-actions">
            <a href="#como-funciona" className="viaja-btn viaja-btn-primary">
              Cómo usar Viajá+ en Alohar
            </a>
            <a href="#beneficios" className="viaja-btn viaja-btn-secondary">
              Ver beneficios
            </a>
          </div>
          <p className="viaja-hero-footnote">
            *El financiamiento y las condiciones son otorgados y administrados exclusivamente por Banco Nación.
          </p>
        </div>
        <div className="viaja-hero-side">
          <div className="viaja-card viaja-card-hero">
            <h2>¿Qué podés hacer con Viajá+?</h2>
            <ul>
              <li>Financiar tu estadía en Alohar en cuotas fijas.</li>
              <li>Aprovechar descuentos y cuotas sin interés en hotelería.</li>
              <li>Ordenar mejor tus gastos de viaje mes a mes.</li>
            </ul>
            <div className="viaja-tag-box">
              <span className="viaja-tag">Hasta $5.000.000*</span>
              <span className="viaja-tag">Cuotas fijas</span>
              <span className="viaja-tag">Turismo en Argentina</span>
            </div>
            <p className="viaja-card-footnote">
              *Monto y condiciones sujetos a aprobación del Banco Nación y a la vigencia del programa.
            </p>
          </div>
        </div>
      </header>

      {/* BENEFICIOS */}
      <section id="beneficios" className="viaja-section">
        <div className="viaja-section-header">
          <h2>Beneficios de usar Viajá+ para tu estadía en Alohar</h2>
          <p>
            Alohar es proveedor inscripto en el programa Viajá+ del Banco Nación, por eso podés
            usar este beneficio para pagar tus reservas de alojamiento en la plataforma.
          </p>
        </div>

        <div className="viaja-grid viaja-grid-3">
          <div className="viaja-card">
            <h3>Financiá tus vacaciones</h3>
            <p>
              Solicitá desde la app BNA+ el préstamo especial Viajá+ para turismo y usalo para pagar
              tu estadía en Alohar. Viajás ahora, lo pagás en cuotas fijas todos los meses.
            </p>
          </div>
          <div className="viaja-card">
            <h3>Cuotas y descuentos en hotelería</h3>
            <p>
              Viajá+ incluye promociones con <strong>cuotas sin interés</strong> y descuentos en hotelería
              y hosterías adheridas. Al reservar en Alohar, podés aprovechar estas promos cuando
              pagás con los medios habilitados por el Banco Nación.
            </p>
          </div>
          <div className="viaja-card">
            <h3>Más orden, menos estrés financiero</h3>
            <p>
              En lugar de pagar todo de una sola vez, distribuís el costo del viaje en el tiempo
              según el plazo que elijas en la app BNA+. Todo el proceso es digital y queda
              registrado en tu cuenta del Banco Nación.
            </p>
          </div>
        </div>
      </section>

      {/* COMO FUNCIONA */}
      <section id="como-funciona" className="viaja-section viaja-section-alt">
        <div className="viaja-section-header">
          <h2>Cómo usar Viajá+ para pagar tu alojamiento en Alohar</h2>
          <p>Seguí estos pasos para aprovechar el programa y financiar tu estadía.</p>
        </div>

        <div className="viaja-steps">
          <div className="viaja-step">
            <div className="viaja-step-number">1</div>
            <div className="viaja-step-content">
              <h3>Elegí tu alojamiento en Alohar</h3>
              <p>
                Buscá tu destino, compará opciones y reservá el alojamiento que más te guste
                dentro de la plataforma Alohar. En el detalle vas a ver si el alojamiento
                participa del programa Viajá+ del Banco Nación.
              </p>
            </div>
          </div>

          <div className="viaja-step">
            <div className="viaja-step-number">2</div>
            <div className="viaja-step-content">
              <h3>Ingresá a la app BNA+ y activá Viajá+</h3>
              <p>
                Desde tu celular, abrí la app <strong>BNA+</strong> y buscá la sección{" "}
                <strong>Viajá+</strong>. Ahí vas a poder solicitar el préstamo Viajá+ para
                turismo o ver las promociones vigentes de cuotas y descuentos para hotelería.
              </p>
            </div>
          </div>

          <div className="viaja-step">
            <div className="viaja-step-number">3</div>
            <div className="viaja-step-content">
              <h3>Confirmá el financiamiento con el Banco Nación</h3>
              <p>
                Seguí los pasos que te indique la app BNA+: elegí monto, plazo y medio de pago
                (por ejemplo, tus tarjetas del Banco Nación a través de MODO BNA+). El banco se
                encarga de aprobar la operación y mostrarte las condiciones.
              </p>
            </div>
          </div>

          <div className="viaja-step">
            <div className="viaja-step-number">4</div>
            <div className="viaja-step-content">
              <h3>Pagá tu estadía en Alohar con Viajá+</h3>
              <p>
                Volvé a Alohar y completá el pago de tu reserva usando los medios habilitados
                por el Banco Nación para Viajá+. El alojamiento cobra normalmente y vos ves el
                consumo financiado en tu cuenta del banco.
              </p>
            </div>
          </div>

          <div className="viaja-step">
            <div className="viaja-step-number">5</div>
            <div className="viaja-step-content">
              <h3>Disfrutá el viaje, pagándolo en cuotas</h3>
              <p>
                Tu reserva queda confirmada en Alohar y tu viaje se paga mes a mes, según las
                condiciones aceptadas en la app BNA+. Todo el seguimiento de las cuotas lo hacés
                directamente con el Banco Nación.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* REQUISITOS */}
      <section className="viaja-section viaja-section-compact">
        <div className="viaja-grid viaja-grid-2">
          <div>
            <h2>Requisitos para usar Viajá+</h2>
            <ul className="viaja-list">
              <li>Ser cliente del Banco Nación.</li>
              <li>Tener la app BNA+ instalada y operativa.</li>
              <li>
                Contar con capacidad crediticia y cumplir las condiciones definidas por el Banco
                Nación.
              </li>
              <li>
                Reservar alojamientos dentro de Argentina que estén adheridos a Viajá+ a través de
                Alohar.
              </li>
              <li>
                Utilizar los medios de pago indicados por el Banco Nación (por ejemplo, tarjetas
                del BNA y MODO BNA+).
              </li>
            </ul>
          </div>
          <div className="viaja-card viaja-card-note">
            <h3>Importante</h3>
            <p>
              Alohar no define tasas, montos ni plazos de financiación. Toda la operatoria de
              crédito, promociones y aprobación corre por cuenta del Banco Nación a través de
              Viajá+. Te recomendamos revisar siempre la información actualizada en la app BNA+
              antes de confirmar tu reserva.
            </p>
          </div>
        </div>
      </section>

      {/* CTA PRINCIPAL */}
      <section className="viaja-section viaja-cta">
        <div className="viaja-cta-inner">
          <h2>¿Listo para planear tu próximo viaje?</h2>
          <p>
            Elegí tu alojamiento en Alohar, activá Viajá+ en la app BNA+ y empezá a viajar por
            Argentina pagando tu estadía en cuotas.
          </p>
          <div className="viaja-hero-actions">
            <a href="/alojamientos" className="viaja-btn viaja-btn-primary">
              Buscar alojamiento en Alohar
            </a>
            <a
              href="https://semananacion.com.ar/semananacion/turismo25"
              target="_blank"
              rel="noopener noreferrer"
              className="viaja-btn viaja-btn-secondary"
            >
              Ir a la web del Banco Nación
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="viaja-section">
        <div className="viaja-section-header">
          <h2>Preguntas frecuentes sobre Viajá+ y Alohar</h2>
        </div>
        <div className="viaja-faq">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={
                "viaja-faq-item " + (openFaqIndex === index ? "viaja-faq-item-open" : "")
              }
            >
              <button
                type="button"
                className="viaja-faq-question"
                onClick={() => toggleFaq(index)}
              >
                <span>{item.question}</span>
                <span className="viaja-faq-icon">
                  {openFaqIndex === index ? "−" : "+"}
                </span>
              </button>
              {openFaqIndex === index && (
                <div className="viaja-faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* FOOTER LEGAL */}
      <footer className="viaja-footer">
        <p>
          Viajá+ es un programa del Banco de la Nación Argentina. Alohar actúa únicamente como
          proveedor de servicios turísticos adherido, sin participar en la evaluación crediticia,
          otorgamiento de préstamos ni definición de condiciones financieras.
        </p>
        <p>
          La información de esta página tiene carácter orientativo. Para conocer las condiciones
          vigentes, tasas, montos y requisitos actualizados, consultá siempre los canales oficiales
          del Banco Nación y la app BNA+.
        </p>
      </footer>
    </div>
  );
}
